export default class ModalQueryMfSubQueryController {
	/* @ngInject */
	/**
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {any} item
	 */
	constructor($uibModalInstance, item) {
		this.$uibModalInstance = $uibModalInstance;
		this.item = item;
		this.tmp = undefined;
	}

	/**
	 * @param {any} item
	 */
	submit(item) {
		if (item) {
			this.$uibModalInstance.close(item);
		}
	}

	cancel() {
		this.$uibModalInstance.dismiss('cancel');
	}
}
